import {
  getAttributeList,
  initQueryParams,
  makeDatesQueryParams,
  makeQueryParam$eq,
  makeQueryParam$ne,
  makeQueryParam$null,
  makeQueryParam$instr,
  makeQueryParam$date,
  makeQueryParam$is,
  makeQueryParam$hasValue,
  makeSearchQueryParams,
} from '@/business/apiTreatment/request/queryParamsUtils';
import { OrdsQueryParams } from '@/business/apiTreatment/request/reusableBaseRequest';

export interface MakeListRequestOpts {
  limitItemsRequest?: number;
  useEntities?: boolean;
  navFullIdField?: string;
  dateField?: string;
  dateNullable?: string;
  defaultOrderBy?: string;
  customFunc?: (params: any[]) => void;
}

export interface ListRequestOpts {
  search?: string;
  page?: number;
  pageSize?: number;
  entities?: any[];
  sort: any;
  sortBy?: string;
  attributesObj?: any;
  dateMin?: any;
  dateMax?: any;
}
/**
 * Business function. make query newItem function for API call.
 * @param {array} searchAttributesArray the attributes to search in
 * @param {boolean} useEntities
 * @returns {function({search?: *, page?: *, pageSize?: *, entities?: *, sort: *, sortBy: *, attributesObj: *, serverSideAttributeKeys: *}): {limit: (*|number)}} The makeQueryParams function.
 */
function makeListRequest({
  limitItemsRequest,
  useEntities,
  navFullIdField = 'entity_nav_full_id',
  dateField,
  dateNullable,
  customFunc,
}: MakeListRequestOpts) {
  return ({
    search,
    page,
    pageSize,
    entities,
    sort,
    sortBy,
    attributesObj,
    dateMin,
    dateMax,
  }: ListRequestOpts): OrdsQueryParams => {
    const AndQueryParams = [];
    const queryParams = initQueryParams({
      limitItemsRequest,
      pageSize,
      page,
      sort,
      sortBy,
      useEntities,
      entities,
      navFullIdField,
      AndQueryParams,
    });

    getAttributeList(attributesObj, '$eq').forEach(
      makeQueryParam$eq(attributesObj, AndQueryParams)
    );
    getAttributeList(attributesObj, '$ne').forEach(
      makeQueryParam$ne(attributesObj, AndQueryParams)
    );
    getAttributeList(attributesObj, '$null').forEach(
      makeQueryParam$null(attributesObj, AndQueryParams)
    );
    getAttributeList(attributesObj, '$instr').forEach(
      makeQueryParam$instr(attributesObj, AndQueryParams)
    );
    getAttributeList(attributesObj, '$instr~,').forEach(
      makeQueryParam$instr(attributesObj, AndQueryParams, ',')
    );
    getAttributeList(attributesObj, '$date').forEach(
      makeQueryParam$date(attributesObj, AndQueryParams)
    );
    getAttributeList(attributesObj, '$is').forEach(
      makeQueryParam$is(attributesObj, AndQueryParams)
    );
    getAttributeList(attributesObj, '$hasValue').forEach(
      makeQueryParam$hasValue(attributesObj, AndQueryParams)
    );

    makeSearchQueryParams(search, AndQueryParams);
    makeDatesQueryParams(
      dateField,
      dateNullable,
      dateMin,
      AndQueryParams,
      dateMax
    );

    if (customFunc) {
      customFunc(AndQueryParams);
    }

    if (AndQueryParams.length > 0) {
      queryParams.q = {
        ...queryParams.q,
        $and: AndQueryParams,
      };
    }
    return queryParams;
  };
}

export { makeListRequest };
export default makeListRequest;
